export const api_version = 1;
export const app_version = '1.1';
export const build = '2026.05.08.16.00';
export const dev_env = false;
export const dev_analytics = process.env.NODE_ENV === 'development';

export const server = dev_env ? 'http://duralabs.local' : 'https://duralabs.io';

export default {
    app_version: app_version,
    build: build,
    dev_analytics: dev_analytics,
    dev_env: dev_env,
    version: api_version,
    server: server
}
